<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model
      :model="formData"
      ref="form"
    >
      <a-form-model-item
        label="计划开始时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="scheduledStartDate"
        :rules="rules.scheduledStartDate"
        v-if="fieldType==='scheduledStartDate'"
      >
        <a-date-picker
          v-model="formData.scheduledStartDate"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          :disabled-date="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item
        label="计划完成时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="scheduledCompletionDate"
        :rules="rules.scheduledCompletionDate"
        v-if="fieldType==='scheduledCompletionDate'"
      >
        <a-date-picker
          v-model="formData.scheduledCompletionDate"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
          :disabled-date="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item
        label="交货时间"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="deliveryDate"
        :rules="rules.deliveryDate"
        v-if="fieldType==='deliveryDate'"
      >
        <a-date-picker
          v-model="formData.deliveryDate"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          :disabled-date="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item
        label="未完成数量交期"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="estimatedDeliveryDate"
        :rules="rules.estimatedDeliveryDate"
        v-if="fieldType==='estimatedDeliveryDate'"
      >
        <a-date-picker v-model="formData.estimatedDeliveryDate" valueFormat="YYYY-MM-DD 00:00:00" :disabled-date="disabledDate" />
      </a-form-model-item>
      <a-form-model-item
        label="考核交期"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        prop="assessmentDeliveryDate"
        :rules="rules.assessmentDeliveryDate"
        v-if="fieldType==='assessmentDeliveryDate'"
      >
        <!--零部件要求展示时分秒，组装成品不用展示时分秒-->
        <a-date-picker
          v-if="signVal==='COMPONENT_JOB'"
          v-model="formData.assessmentDeliveryDate"
          format="YYYY-MM-DD HH:mm:ss"
          :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
        />
        <a-date-picker v-else v-model="formData.assessmentDeliveryDate" valueFormat="YYYY-MM-DD 00:00:00" />

      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiUpdateBatchData } from '@/api/mes/workOrderManage/workOrderDesk'
import moment from 'moment';

export default {
  name: 'BatchEditModal',
  data() {
    return {
      fieldType: '', // 修改字段标识
      modal: false,
      signVal: '', // 标识字段
      formData: {
        scheduledStartDate: "",
        scheduledCompletionDate: '',
        deliveryDate: '',
        estimatedDeliveryDate: '',
        assessmentDeliveryDate: ''
      },
      loading: false,
      rules: {
        scheduledStartDate: [{ required: true, message: ' ', trigger: 'change' }],
        scheduledCompletionDate: [{ required: true, message: ' ', trigger: 'change' }],
        deliveryDate: [{ required: true, message: ' ', trigger: 'change' }],
        estimatedDeliveryDate: [{ required: true, message: ' ', trigger: 'change' }],
        assessmentDeliveryDate: [{ required: true, message: ' ', trigger: 'change' }]
      },
      selectedRows: []
    }
  },
  methods: {
    moment,
    show (list, field, sign) {
      this.fieldType = field // 区分修改字段标识
      this.signVal = sign
      this.selectedRows = list
      this.formData.scheduledStartDate = ""
      this.formData.scheduledCompletionDate = ""
      this.formData.deliveryDate = ""
      this.formData.estimatedDeliveryDate = ""
      this.formData.assessmentDeliveryDate = ""
      this.modal = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          const ids = this.selectedRows.map(item => item.id)
          const params = { ids: ids }
          if (this.formData[this.fieldType]) {
            params[this.fieldType] = this.$moment(this.formData[this.fieldType]).format('YYYY-MM-DD HH:mm:ss')
            // 修改计划完成时间，计划开始时间默认为完成时间当天的8点
            if(this.fieldType === 'scheduledCompletionDate') {
              params.scheduledStartDate = this.$moment(this.formData[this.fieldType]).format('YYYY-MM-DD 08:00:00')
            }
          } else {
            this.$message.warning('未获取到日期')
            return false;
          }
          this.loading = true;
          apiUpdateBatchData(params).then(response => {
            if (response.code === 200) {
              this.modal = false
              this.$message.success('修改完成!')
              this.$emit("click")
            } else {
              this.$message.error(response.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 选择限制当前和以后日期
    disabledDate (current) {
      return current && current <= this.$moment().subtract(1, 'day');
    }
  }
}
</script>

<style scoped>

</style>
